export const PACKAGE_POSITIONS = {
    TABS: 'upper_packages',
    TABLE: 'packages_table',
    TOP_RIGHT: 'Top Right'
};
